<div class="modal-header">
	<div>
		<h4 class="modal-title" id="modal-basic-title">{{'home.recordpickup.recordDelivery'| cxTranslate}}</h4>
     <p>{{ deliveryData.nomination }} </p>
     </div>
        <i class="fa fa-times close-icon" aria-hidden="true" (click)="cancel()"></i>
</div>
<div id="loader"*ngIf="enableLoader" class="overlay-loader loading-spinner"></div>
<div class="modal-body">
  <div *ngIf="!enableLoader">

  
  <!-- Confirmation Section -->
    <div>
      <p class="Cheading">{{'home.recordpickup.pleaseConfirmComplete' | cxTranslate}}</p>
    </div>

    <!-- Delivery Details Table -->
    <div>
      <table class="table">
        <thead>
          <tr>
            <th>{{'home.recordpickup.deliveryQuantity'| cxTranslate}}</th>
            <th>{{'home.recordpickup.deliveryDate'| cxTranslate}}</th>
            <th>{{'home.recordpickup.deliveryMode'| cxTranslate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of deliveryData?.nominationItemRecordPickUpEntryRequest">
            <td>{{ item.quantityCollected | number:'1.0-3' }}</td>
            <td>{{ item.dateCollected | date:'dd/MM/yyyy' }}</td>
            <td>{{ item.portsidePartnerTransportEnum }}</td>
          </tr>
          <tr class="font-weight-bold total-row">
            <td colspan="3">
              <div class="total-delivery-container">
                <div class="total-left">
                  {{totalCount | number:'1.0-3'}}
                  <!-- Info SVG before validation -->
                  <img src="/images/info.svg" *ngIf="(azureStatus | lowercase)=='not_initiated'" [ngbTooltip]="'home.recordpickup.AzureNotValidated' | cxTranslate"   alt="customlogo" width="20px" height="20px">
                  <!-- Warning SVG only after validation attempt and failure -->
                  <img src="/images/warning.svg" *ngIf="(azureStatus | lowercase) === 'failure' " [ngbTooltip]="'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate" alt="customlogo" width="20px" height="20px" >
                  <!-- Success SVG only after validation attempt and success -->
                  <img src="/images/check_circle.svg" *ngIf="(azureStatus | lowercase) === 'success' " [ngbTooltip]="'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate" alt="customlogo" width="20px" height="20px" >
                  <img src="/images/partial_success.svg" *ngIf="(azureStatus | lowercase) === 'partial_success' " [ngbTooltip]="'home.recordpickup.AzurePartialSuccess' | cxTranslate" alt="customlogo" width="20px" height="20px" >
                  <img src="/images/pending.svg" *ngIf="(azureStatus | lowercase) === 'in_progress' " [ngbTooltip]="'home.recordpickup.AzureValidating' | cxTranslate" alt="customlogo" width="20px" height="20px" >
                </div>
                <div class="total-center">
                  {{'home.recordpickup.totalDelivery' | cxTranslate}}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Validation Error Message -->
    <!--Not yet validated-->
      <div *ngIf="(azureStatus | lowercase)=='not_initiated'" class="mt-2 pt-3 pb-3 pl-3 validate-msg" role="alert"style = "color: #666666 ; background-color: #84B5D91F;display:flex;justify-content: center">
    {{'home.recordpickup.validationResults' | cxTranslate}}
      </div>
        
    
      <!--In progress-->
      <div *ngIf="(azureStatus | lowercase)=='in_progress'" class="alert alert-info mt-2 validate-msg" role="alert" style = "background-color:#E59D0742;color: #5C1715;border-radius: 4px; border: 1px solid #DD5900; display: flex;
    justify-content: flex-start;">
     {{'home.recordpickup.dataSubmitted' | cxTranslate}}
      </div>
      <!-- Validation success message -->
      <div *ngIf="(azureStatus | lowercase) === 'success' " class=" mt-2 pt-3 pb-3 validate-msg" style=" border: 1px solid #bdbdbd; background: #84B5D91F;color: #1A1A1A;display: flex;justify-content: center;">
     {{azureValidationRemark}}
      </div>
      <!-- Validation error message -->
      <div  *ngIf="(azureStatus | lowercase) === 'failure' "class="mt-2 p-2 validate-msg" style="background: #84B5D91F;border: 1px solid #FF2D41; display: block;color: #5C1715">
        {{azureValidationRemark}}
      </div>
    <div *ngIf="(azureStatus | lowercase) === 'partial_success' " class="mt-2 pt-3 pb-3 pl-4" style="border: 1px solid #048A24; background: #12983242;display: block;color: #001B1A">
      {{azureValidationRemark}}
      </div>

    <!-- Remarks Section -->
    <div class="form-group mb-4">
      <label class="font-weight-bold">{{'home.recordpickup.remarks'| cxTranslate}}</label>
      <p>
        {{deliveryData.remarks   }}
      </p>
      <!-- <small *ngIf="recordDeliveryForm.get('remarks')?.touched && recordDeliveryForm.get('remarks')?.invalid" class="text-danger">
        Remarks are required
      </small> -->
    </div>

    <!-- Attached Documents Section -->
    <div class="attached-documents mb-4">
      <label class="font-weight-bold">{{'tenders.Attachment' | cxTranslate}}</label>
      <div class="document-list">
        <div *ngIf="attachedFiles && attachedFiles.length > 0; else noFiles">
          <div *ngFor="let file of attachedFiles; let i = index" class="d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
            <div class="d-flex align-items-center">
              <i class="far fa-file-pdf text-danger mr-2"></i>
              <div>
                <div class="file-name">{{ file.name }}</div>
                <small class="text-muted">{{ (file.size / 1024 / 1024) | number:'1.2-2' }} MB</small>
              </div>
            </div>
            <!-- <button 
              type="button" 
              class="btn btn-sm btn-link text-danger"
              (click)="removeAttachment(i)">
              <i class="fas fa-trash"></i>
            </button> -->
          </div>
        </div>
        <ng-template #noFiles>
          <p class="text-muted">No attached documents</p>
        </ng-template>
      </div>
    </div>

    <!-- Warning Alert -->
      <div class=" border-style p-2 alert-warning warning-msg" style="font-weight: 400;" role="alert">
      <div *ngIf="show10percentError">
        <i class="fas fa-exclamation-triangle mr-2" style="color: #B77E06;"></i>
       {{'home.recordpickup.totalDeliveryDiff' | cxTranslate}}
      </div>
      <div>
        <i *ngIf="!show10percentError" class="fas fa-exclamation-triangle mr-2" style="color: #B77E06;"></i>
        {{'home.recordpickup.onceSaved' | cxTranslate}}
      </div>
    </div>
  
</div>
</div>
<div class="modal-footer border-top pt-3" *ngIf = "!enableLoader">
    <button type="button" class="btn btn-primary"
        [disabled]="!recordDeliveryForm.valid" (click)="onConfirm()">
        {{'home.recordpickup.confirm' | cxTranslate}}
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="onBack()">
        {{'shipment.back'|cxTranslate}}
    </button>

</div>
